import { Virtuoso } from 'react-virtuoso';
import * as R from 'ramda';

import { SearchResultsType } from '@atom/types/search';

import InventoryResultRow from './InventoryResultRow';
import UserResultRow from './UserResultRow';
import WorkResultRow from './WorkResultRow';

const styles = {
  virtuoso: {
    height: '100%',
  },
};

interface Props {
  query: string;
  results: SearchResultsType;
}

const AllResults = ({ query, results }: Props) => {
  const allResults = [
    ...R.pathOr([], ['assets'], results),
    ...R.pathOr([], ['workOrders'], results),
    ...R.pathOr([], ['users'], results),
  ];

  return (
    <Virtuoso
      style={styles.virtuoso}
      data={allResults}
      itemContent={(_, item) => {
        const rowDisplay = {
          AssetResult: <InventoryResultRow query={query} asset={item} />,
          WorkOrderResult: <WorkResultRow query={query} work={item} />,
          UserResult: <UserResultRow query={query} user={item} />,
        };

        return rowDisplay[item?.__typename];
      }}
    />
  );
};

export default AllResults;
